import { useState } from "react";
import "./editorialForms.css";

const propertyTypes = [
  { id: "entire_place", name: "Espaço inteiro" },
  { id: "private_room", name: "Quarto privativo" },
  { id: "shared_room", name: "Quarto compartilhado" },
];

const amenitiesList = [
  "Wi-Fi",
  "Cozinha",
  "Ar Condicionado",
  "Aquecimento",
  "TV",
  "Máquina de Lavar",
  "Secadora",
  "Estacionamento",
  "Piscina",
  "Jacuzzi",
  "Churrasqueira",
  "Varanda",
  "Vista para o mar",
  "Espaço de trabalho",
  "Ferro de passar",
  "Secador de cabelo",
];

export default function AirbnbForm({ data, onChange }) {
  const [ruleInput, setRuleInput] = useState("");

  const handleToggleAmenity = (amenity) => {
    const current = data?.amenities || [];
    if (current.includes(amenity)) {
      onChange({
        ...data,
        amenities: current.filter((a) => a !== amenity),
      });
    } else {
      onChange({
        ...data,
        amenities: [...current, amenity],
      });
    }
  };

  const handleAddRule = () => {
    if (ruleInput.trim()) {
      onChange({
        ...data,
        houseRules: [...(data?.houseRules || []), ruleInput.trim()],
      });
      setRuleInput("");
    }
  };

  const handleRemoveRule = (index) => {
    onChange({
      ...data,
      houseRules: (data?.houseRules || []).filter((_, i) => i !== index),
    });
  };

  return (
    <div className="editorial_form airbnb_form">
      <div className="editorial_form_section">
        <label>
          Título do Anúncio <span className="required">*</span>
        </label>
        <input
          type="text"
          placeholder="Ex: Apartamento aconchegante no centro"
          value={data?.title || ""}
          onChange={(e) => onChange({ ...data, title: e.target.value })}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Tipo de Espaço</label>
          <select
            value={data?.propertyType || ""}
            onChange={(e) => onChange({ ...data, propertyType: e.target.value })}
          >
            <option value="">Selecione</option>
            {propertyTypes.map((type) => (
              <option key={type.id} value={type.id}>
                {type.name}
              </option>
            ))}
          </select>
        </div>

        <div className="editorial_form_section">
          <label>
            Preço por Noite (R$) <span className="required">*</span>
          </label>
          <input
            type="number"
            placeholder="0.00"
            value={data?.pricePerNight || ""}
            onChange={(e) =>
              onChange({ ...data, pricePerNight: parseFloat(e.target.value) || 0 })
            }
            min="0"
            step="0.01"
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Descrição</label>
        <textarea
          placeholder="Descreva seu espaço, o que o torna especial..."
          value={data?.description || ""}
          onChange={(e) => onChange({ ...data, description: e.target.value })}
          maxLength={2000}
          rows={3}
        />
      </div>

      <div className="editorial_form_section">
        <label>Localização</label>
        <input
          type="text"
          placeholder="Bairro, Cidade"
          value={data?.address || ""}
          onChange={(e) => onChange({ ...data, address: e.target.value })}
        />
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Cidade</label>
          <input
            type="text"
            placeholder="Cidade"
            value={data?.city || ""}
            onChange={(e) => onChange({ ...data, city: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>País</label>
          <input
            type="text"
            placeholder="País"
            value={data?.country || "Brasil"}
            onChange={(e) => onChange({ ...data, country: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Hóspedes</label>
          <input
            type="number"
            placeholder="Máx. hóspedes"
            value={data?.maxGuests || ""}
            onChange={(e) =>
              onChange({ ...data, maxGuests: parseInt(e.target.value) || 0 })
            }
            min="1"
          />
        </div>

        <div className="editorial_form_section">
          <label>Quartos</label>
          <input
            type="number"
            placeholder="Quartos"
            value={data?.bedrooms || ""}
            onChange={(e) =>
              onChange({ ...data, bedrooms: parseInt(e.target.value) || 0 })
            }
            min="0"
          />
        </div>

        <div className="editorial_form_section">
          <label>Camas</label>
          <input
            type="number"
            placeholder="Camas"
            value={data?.beds || ""}
            onChange={(e) =>
              onChange({ ...data, beds: parseInt(e.target.value) || 0 })
            }
            min="0"
          />
        </div>

        <div className="editorial_form_section">
          <label>Banheiros</label>
          <input
            type="number"
            placeholder="Banheiros"
            value={data?.bathrooms || ""}
            onChange={(e) =>
              onChange({ ...data, bathrooms: parseInt(e.target.value) || 0 })
            }
            min="0"
            step="0.5"
          />
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Taxa de Limpeza (R$)</label>
          <input
            type="number"
            placeholder="0.00"
            value={data?.cleaningFee || ""}
            onChange={(e) =>
              onChange({ ...data, cleaningFee: parseFloat(e.target.value) || 0 })
            }
            min="0"
            step="0.01"
          />
        </div>

        <div className="editorial_form_section">
          <label>Mínimo de Noites</label>
          <input
            type="number"
            placeholder="1"
            value={data?.minimumNights || ""}
            onChange={(e) =>
              onChange({ ...data, minimumNights: parseInt(e.target.value) || 1 })
            }
            min="1"
          />
        </div>
      </div>

      <div className="editorial_form_row">
        <div className="editorial_form_section">
          <label>Check-in</label>
          <input
            type="text"
            placeholder="Ex: 15:00"
            value={data?.checkIn || ""}
            onChange={(e) => onChange({ ...data, checkIn: e.target.value })}
          />
        </div>

        <div className="editorial_form_section">
          <label>Check-out</label>
          <input
            type="text"
            placeholder="Ex: 11:00"
            value={data?.checkOut || ""}
            onChange={(e) => onChange({ ...data, checkOut: e.target.value })}
          />
        </div>
      </div>

      <div className="editorial_form_section">
        <label>Comodidades</label>
        <div className="genre_chips">
          {amenitiesList.map((amenity) => (
            <span
              key={amenity}
              className={`genre_chip ${
                (data?.amenities || []).includes(amenity) ? "selected" : ""
              }`}
              onClick={() => handleToggleAmenity(amenity)}
            >
              {amenity}
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <label>
          Regras da Casa
          <button
            type="button"
            className="add_variant_btn"
            onClick={handleAddRule}
          >
            + Adicionar
          </button>
        </label>
        <input
          type="text"
          placeholder="Ex: Não fumar, Não fazer festas..."
          value={ruleInput}
          onChange={(e) => setRuleInput(e.target.value)}
          onKeyPress={(e) => e.key === "Enter" && handleAddRule()}
        />
        <div className="genre_chips" style={{ marginTop: "8px" }}>
          {(data?.houseRules || []).map((rule, i) => (
            <span
              key={i}
              className="genre_chip selected"
              onClick={() => handleRemoveRule(i)}
              style={{ cursor: "pointer" }}
            >
              {rule} ×
            </span>
          ))}
        </div>
      </div>

      <div className="editorial_form_section">
        <div className="editorial_form_checkbox">
          <input
            type="checkbox"
            id="isSuperhost"
            checked={data?.isSuperhost || false}
            onChange={(e) => onChange({ ...data, isSuperhost: e.target.checked })}
          />
          <label htmlFor="isSuperhost">Sou Superhost</label>
        </div>
      </div>

      <div className="editorial_form_tip">
        <svg viewBox="0 0 24 24" fill="currentColor" width="16" height="16">
          <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
        </svg>
        <span>
          Fotos de alta qualidade aumentam suas chances de reserva em até 40%!
        </span>
      </div>
    </div>
  );
}
